if (!customElements.get('cart-new-countdown')) {
  customElements.define(
    'cart-new-countdown',
    class CartNewCountdown extends HTMLElement {
      connectedCallback() {
        this.duration = Math.max(60, Number(this.dataset.durationSeconds) || 1200);
        this.storageKey = this.dataset.storageKey;
        this.savingsUrl = this.dataset.savingsUrl;
        this.minutesElement = this.querySelector('[data-countdown-minutes]');
        this.secondsElement = this.querySelector('[data-countdown-seconds]');
        this.timerElement = this.querySelector('[role="timer"]');
        this.savingsElement = this.querySelector('[data-cart-savings]');
        this.handleCartChange = this.refreshSavings.bind(this);

        if (!this.minutesElement || !this.secondsElement) return;

        this.stop();
        this.expiration = this.getExpiration();
        this.update();
        this.interval = window.setInterval(() => this.update(), 1000);
        document.addEventListener('theme:cart:change', this.handleCartChange);
      }

      disconnectedCallback() {
        this.stop();
        this.savingsRequest?.abort();
        document.removeEventListener('theme:cart:change', this.handleCartChange);
      }

      getExpiration() {
        const now = Date.now();
        let expiration = null;

        try {
          expiration = Number(window.localStorage.getItem(this.storageKey));
        } catch (error) {
          expiration = null;
        }

        if (!Number.isFinite(expiration) || expiration <= 0) {
          return this.saveExpiration(now + this.duration * 1000);
        }

        if (expiration <= now) {
          const elapsedCycles = Math.floor((now - expiration) / (this.duration * 1000)) + 1;
          expiration += elapsedCycles * this.duration * 1000;
          return this.saveExpiration(expiration);
        }

        return expiration;
      }

      saveExpiration(expiration) {
        try {
          window.localStorage.setItem(this.storageKey, String(expiration));
        } catch (error) {
          // The countdown still works when storage is unavailable.
        }

        return expiration;
      }

      update() {
        const now = Date.now();

        if (!this.expiration || this.expiration <= now) {
          this.expiration = this.getExpiration();
        }

        const remainingSeconds = Math.max(0, Math.ceil((this.expiration - now) / 1000));
        const minutes = Math.floor(remainingSeconds / 60);
        const seconds = remainingSeconds % 60;

        this.minutesElement.textContent = String(minutes).padStart(2, '0');
        this.minutesElement.classList.toggle('is-long-value', minutes > 99);
        this.secondsElement.textContent = String(seconds).padStart(2, '0');
        this.timerElement?.setAttribute('aria-label', `${minutes} minutes ${seconds} seconds remaining`);
      }

      refreshSavings() {
        if (!this.savingsElement || !this.savingsUrl) return;

        this.savingsRequest?.abort();
        this.savingsRequest = new AbortController();

        fetch(this.savingsUrl, {signal: this.savingsRequest.signal})
          .then((response) => {
            if (!response.ok) throw new Error(`Cart section request failed: ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const responseContainer = document.createElement('div');
            responseContainer.innerHTML = html;

            const updatedBlock = responseContainer.querySelector(
              `cart-new-countdown[data-block-id="${this.dataset.blockId}"]`
            );
            const updatedSavings = updatedBlock?.querySelector('[data-cart-savings]');

            if (updatedSavings) {
              this.savingsElement.textContent = updatedSavings.textContent.trim();
              this.savingsElement.dataset.savingsValue = updatedSavings.dataset.savingsValue;
            }
          })
          .catch((error) => {
            if (error.name === 'AbortError') return;
            // Keep the last rendered savings value if the cart request fails.
          });
      }

      stop() {
        if (this.interval) {
          window.clearInterval(this.interval);
          this.interval = null;
        }
      }
    }
  );
}
